(function (angular) {
    "use strict";

    angular
        .module('harriApp')
        .controller('HMAPRawDataReportingController', ["$scope", "$q", "$alert", "hUser", "hmapService", "userServices", '$modal', 'userPermissions', 'brandServices', function ($scope, $q, $alert, hUser, hmapService, userServices, $modal, userPermissions, brandServices) {
            const activeBrandId = hmapService.getActiveBrand();

            $scope.isLoading = false;
            $scope.selectedSection = '';
            $scope.eeoFormLoaded = false;
            $scope.hasManageAllScheduleReportsPermission = false;
            $scope.availableTabs = {
                SCHEDULED_EXPORTS: 'SCHEDULED_EXPORTS',
                RAW: 'RAW',
                EEO: 'EEO'
            };

            async function init() {
                $scope.isLoading = true;

                const promises = [
                    brandServices.check(brandServices.SERVICES.SCHEDULE_REPORTS, activeBrandId),
                    userServices.isServiceEnabled(userServices.SERVICES.RAW_DATA_REPORTING, activeBrandId),
                    userServices.isServiceEnabled(userServices.SERVICES.EEO_REPORT, activeBrandId),
                    userPermissions.hasPermissionOnBrandOrAnyChild(
                        activeBrandId,
                        userPermissions.PERMISSIONS.MANAGE_ALL_SCHEDULED_REPORTS,
                        userPermissions.PERMISSION_CATEGORIES.HARRI
                    ),
                    userPermissions.hasPermissionOnBrandOrAnyChild(
                        activeBrandId,
                        userPermissions.PERMISSIONS.SCHEDULE_REPORTS,
                        userPermissions.PERMISSION_CATEGORIES.HARRI
                    ),
                ];

                const [
                    isScheduledExportEnabled,
                    isRawReportingServiceEnabled,
                    isEEOServiceEnabled,
                    hasManageAllScheduledReportsPermission,
                    hasScheduleReportsPermission,
                ] = await Promise.all(promises);

                $scope.isScheduledExportEnabled = isScheduledExportEnabled;
                $scope.isRawReportingServiceEnabled = isRawReportingServiceEnabled;
                $scope.isEEOServiceEnabled = isEEOServiceEnabled;
                $scope.hasManageAllScheduleReportsPermission =  hasManageAllScheduledReportsPermission;
                $scope.hasScheduleReportsPermission =  hasScheduleReportsPermission;

                let activeTab = null;
                if (isScheduledExportEnabled && ($scope.hasManageAllScheduleReportsPermission || $scope.hasScheduleReportsPermission)) {
                    activeTab = 'SCHEDULED_EXPORTS';
                } else {
                    if (isRawReportingServiceEnabled) {
                        activeTab = 'RAW';
                    } else if (isEEOServiceEnabled) {
                        activeTab = 'EEO';
                    }
                }

                if (isEEOServiceEnabled) {
                    $scope.eeoReportingForm = new HMAPEEOReportingForm($scope);
                    $scope.eeoReportingForm.onViewLoaded();
                }

                $scope.setActiveTab(activeTab);
                $scope.isLoading = false;
                $scope.$digest();
            }

            init();

            $scope.setActiveTab = (activeTab, fromUser = false) => {
                if (!fromUser && $scope.selectedSection) return;

                $scope.selectedSection = activeTab;
                if (activeTab === $scope.availableTabs.EEO && $scope.isEEOServiceEnabled && !$scope.eeoFormLoaded) {
                    $scope.eeoReportingForm.load(activeBrandId);
                    $scope.eeoFormLoaded = true;
                }
            };

            var HMAPRawDataReportingForm = function ($scope, brand) {
                var self = this;
                var formName = "hmap-raw-data-reporting-form";
                var _protected = BaseForm.call(self, formName, $scope);
                var gbBrands = null;

                self.brandId = brand.id;

                self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

                    switch (rule.name) {

                        case 'start-end-dates':

                            if (self.data.fromDate && self.data.toDate) {

                                var start = moment(self.data.fromDate),
                                    end = moment(self.data.toDate);

                                return end >= start;
                            }
                            break;
                    }
                };

                //init
                (function () {
                    GPSAPI.getGP(brand.id)
                        .then(function (res) {
                            gbBrands = res;
                            gbBrands.children = gbBrands.brands;

                            self.data.accessLevelOptions = [angular.copy(gbBrands)];

                            setTimeout(function () {
                                $scope.$digest();
                            }, 1);
                        }, function (err) {
                            console.err("couldn't load your grand parent", err);
                        });
                })();
            };

            $scope.RawDataReportingForm = new HMAPRawDataReportingForm($scope, {id: activeBrandId});
            $scope.RawDataReportingForm.onViewLoaded();

            var HMAPEEOReportingForm = function ($scope) {
                var self = this;
                var formName = "hmap-eeo-reporting-form";
                var _protected = BaseForm.call(self, formName, $scope);

                self.load = function (brandId) {

                    self.brandId = brandId;
                    self.selectedGroup = null;
                    self.data = {};

                    self.groupByItems = [
                        {id: 'POSITION', label: $filter("translate")('Position'), value: 'POSITION'},
                        {id: 'CATEGORY', label: $filter("translate")('Category'), value: 'CATEGORY'},
                        {id: 'TOTAL', label: $filter("translate")('Totals'), value: 'TOTAL'}
                    ];

                    self.selectedGroup = self.groupByItems[0];
                };

                self.save = function () {

                    if (self.validator.validate()) {
                        var params = {
                            from_date: Utils.getISODate(self.data.fromDate),
                            to_date: Utils.getISODate(self.data.toDate),
                            group_by: (self.selectedGroup && self.selectedGroup.id !== 'TOTAL') ? self.selectedGroup.id : null
                        };

                        ReportsAPI.generateGPEEOReport(activeBrandId, params)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });
                    }
                };

                self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

                    switch (rule.name) {

                        case 'start-end-dates':

                            if (self.data.fromDate && self.data.toDate) {

                                var start = moment(self.data.fromDate),
                                    end = moment(self.data.toDate);

                                return end >= start;
                            }

                            break;

                        case 'less-than-12-months':

                            if (self.data.fromDate && self.data.toDate) {

                                var start = moment(self.data.fromDate),
                                    end = moment(self.data.toDate);

                                return end.diff(start, 'months', true) <= 12;
                            }

                            break;
                    }
                };
            };

            $scope.export = function(reportName) {

                if ($scope.RawDataReportingForm.validator.validate()) {

                    var allUnfilledStatuses = [];
                    var brandId = $scope.RawDataReportingForm.brandId;
                    var dataToSend = {
                        'from_date': Utils.getISODate($scope.RawDataReportingForm.data.fromDate),
                        'to_date': Utils.getISODate($scope.RawDataReportingForm.data.toDate)
                    };

                    if (reportName === 'live') {

                        angular.extend(allUnfilledStatuses, $scope.RawDataReportingForm.data.statuses);
                        var unfilledStatuses = [];

                        for (var key in $scope.RawDataReportingForm.data.statuses) {
                            if ($scope.RawDataReportingForm.data.statuses[key]) {
                                unfilledStatuses.push(key);
                            }
                        }

                        if (unfilledStatuses.length > 0) {
                            dataToSend['statuses'] = unfilledStatuses;
                        }

                        ReportsAPI.liveVacancies(brandId, dataToSend)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });

                    } else if (reportName === 'filled') {

                        ReportsAPI.filledVacancies(brandId, dataToSend)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });

                    } else if (reportName === 'talent') {

                        ReportsAPI.talentBank(brandId, dataToSend)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });

                    } else if (reportName === 'workflow') {

                        ReportsAPI.timeInWorkflow(brandId, dataToSend)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });

                    } else if (reportName === 'unfilled') {

                        ReportsAPI.unfilledVacancies(brandId, dataToSend)
                            .then(function (res) {
                                HNotifications.show({
                                    title: $filter("translate")("Success"),
                                    desc: $filter("translate")("Email will be sent to you shortly"),
                                    icon: "fa-check-circle",
                                    type: "success",
                                    timeout: 20000
                                });

                            }, function (err) {
                                HNotifications.show({
                                    title: $filter("translate")("Error"),
                                    desc: $filter("translate")("Something Went Wrong"),
                                    icon: "fa-times-circle",
                                    type: "danger",
                                    timeout: 20000
                                });
                            });
                    }
                }
                else {

                }
            };
        }]);

})(angular);
